import { BroadbandQuote } from '@src/types/broadband';

import { DIGITAL_HOME_PHONE } from '../constants';

const shouldShowDigitalHomePhone = (
  quote: Nullable<BroadbandQuote> | undefined
): boolean => {
  if (!quote) return false;

  const hasDigitalHomePhoneCharge = quote.allProductCharges.some(
    ({ name }) => name === DIGITAL_HOME_PHONE
  );
  const isBroadbandOnly = !!quote.product.details.broadbandOnly;

  return hasDigitalHomePhoneCharge || isBroadbandOnly;
};

export { shouldShowDigitalHomePhone };
